module.exports = __webpack_public_path__ + "img/cimb-settlement.493f5866.png";